// extracted by mini-css-extract-plugin
export default {"tooltip":"yQ-z","arrow":"zQ-z"};